export const AZURE_PROVIDER_NAME = 'azure-ad-oidc';
export const MON_COMPTE_PROVIDER_NAME = 'mon-compte-oidc';

export default {
  AZURE_PROVIDER_NAME,
  MON_COMPTE_PROVIDER_NAME,
};
